// src/context/RegDataContext.js
import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const RegDataContext = createContext();

export const RegDataProvider = ({ children }) => {
  const token = localStorage.getItem("token");
  const [locationsData, setLocationsData] = useState({});
  const [trainers, setTrainers] = useState([]);
  const [coursesData, setCoursesData] = useState({});
  const [courseFeesData, setCourseFeesData] = useState({});
  const [courseDurData, setCourseDurData] = useState({});

  // Fetch locations & branches
  useEffect(() => {
    if (!token) return;

    const fetchLocations = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/regdetail`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const userData = Array.isArray(res.data) ? res.data : [res.data];
        const userLocationsData = {};

        userData.forEach(user => {
          if (!user.location) return;
          const locations = Array.isArray(user.location) ? user.location : [user.location];
          locations.forEach(loc => {
            if (!userLocationsData[loc]) userLocationsData[loc] = { branches: [] };
            if (!userLocationsData[loc].branches.includes(user.branch)) {
              userLocationsData[loc].branches.push(user.branch);
            }
          });
        });

        setLocationsData(userLocationsData);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchLocations();
  }, [token]);

  // Fetch courses
  useEffect(() => {
    if (!token) return;

    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/course`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const coursesByType = {};
        const fees = {};
        const dur = {};

        res.data.forEach(course => {
          coursesByType[course.courseType] = coursesByType[course.courseType] || [];
          if (!coursesByType[course.courseType].includes(course.courseName)) {
            coursesByType[course.courseType].push(course.courseName);
          }
          fees[course.courseName] = course.courseFees;
          dur[course.courseName] = course.courseDuration;
        });

        setCoursesData(coursesByType);
        setCourseFeesData(fees);
        setCourseDurData(dur);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, [token]);

  // Fetch trainers
  const fetchTrainers = async (location, branch) => {
    if (!location || !branch || !token) return;
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/regdetail`, {
        params: { location, branch, role: "Trainer" },
        headers: { Authorization: `Bearer ${token}` },
      });
      setTrainers(Array.isArray(res.data) ? res.data : [res.data]);
    } catch (error) {
      console.error("Error fetching trainers:", error);
    }
  };

  return (
    <RegDataContext.Provider value={{
      locationsData,
      coursesData,
      courseFeesData,
      courseDurData,
      trainers,
      fetchTrainers
    }}>
      {children}
    </RegDataContext.Provider>
  );
};
